import React, { useState, useEffect, useRef } from 'react'
import { Checkbox, Col, Message, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  SaveAssessmentMAndESelfForm,
  SaveAssessmentMAndESelfForm2,
} from '../../redux/actions/assessment'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import MAndESelfForm from './MAndESelfForm'
import MAndESelfView from './MAndESelfView'
import MAndEProjectInfo from './MAndEProjectInfo'

export default function MAndESelfFormWidget({ schema, preView, unauthen, email, ...props }) {
  const history = useHistory()

  const { register, handleSubmit, errors, control, setValue, reset, clearErrors, getValues } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isRefash, setIsRefash] = useState(false)
  const [isLoading, setIsLoading] = useState()
  const [isAccept, setIsAccept] = useState(schema.privacyAccept)

  const [submitSendData, setSubmitSendData] = useState()
  const [result, setResult] = useState(new Map())
  const [basicInfoResult, setBasicInfoResult] = useState(new Map())

  const [extendResult, setExtendResult] = useState(0)

  useEffect(() => {
    // const count = Array.from(basicInfoResult.keys()).filter((key) =>
    //   /^BS_Q\d+-O\d+_E\d+$/.test(key)
    // ).length

    setExtendResult(basicInfoResult?.get('BS_Q1')?.split(',')?.length || 0)
  }, [basicInfoResult])

  const handleCallSaveService = async (request) => {
    setIsLoading(true)
    startLoading()

    try {
      let response
      if (unauthen) {
        response = await SaveAssessmentMAndESelfForm2(request, request.projectCode)
      } else {
        response = await SaveAssessmentMAndESelfForm(request, request.projectCode)
      }
      console.log(response)

      if (response) {
        setFormSchema(response)
        setIsAccept(response.privacyAccept)

        sessionStorage.setItem('m_e_s_id', response.id)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })

        onRefash()
      } else {
        notification.open('error', {
          title: response?.message || DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('MAndESelfFormWidget HandleCallSaveService Error : ', e)

      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data, isDraft) => {
    let assessments = []

    data.assessmentResult?.forEach((value, key) => {
      assessments.push({
        //id: '',
        questionId: key,
        value: value,
      })
    })

    let basicInfos = []

    data.basicInfos?.forEach((value, key) => {
      basicInfos.push({
        //id: '',
        questionId: key,
        value: value,
      })
    })

    let req = {
      id: formSchema.id,
      assessmentId: formSchema.assessmentId,
      projectCode: formSchema.projectCode,
      position: data.position,
      otherPosition: data.otherPosition,
      privacyAccept: isAccept || false,
      basicInfos: basicInfos,
      assessments: assessments,
      isDraft: isDraft,
      email: email,
    }

    console.log('req : ', req)

    setIsShowConfirm(false)
    handleCallSaveService(req)
  }

  const onSubmitDaft = () => {
    let data = {
      position: getValues('position'),
      otherPosition: getValues('otherPosition'),
      assessmentResult: getValues('assessmentResult'),
      basicInfos: getValues('basicInfos'),
    }

    console.log('onSubmitDaft : ', data)

    onSubmit(data, true)
  }

  const onSubmitAndSend = (data) => {
    console.log('onSubmitAndSend:', data)
    setSubmitSendData(data)
    // setIsDraft(false)
    setIsShowConfirm(true)
  }

  const handleCancel = () => {
    if (unauthen) {
      onRefash()
    } else if (preView) {
      history.push(pathname.assessment.assessmentSettingPage)
    } else {
      history.push(pathname.assessment.assessmentMAndESelf)
    }
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel
        shaded
        // collapsible
        // defaultExpanded
        header={<b>{formSchema?.header || ''}</b>}
        style={
          unauthen ? { marginBottom: formSchema.disabled ? 90 : 120, marginTop: 10 } : undefined
        }
        bordered
      >
        {isLoading && <OverlayLoader />}

        {!isRefash && (
          <>
            <MAndEProjectInfo schema={formSchema} />

            <Row style={{ marginTop: 10 }}>
              <Message
                showIcon
                type="info"
                description={
                  <>
                    <p>
                      <b>{formSchema.privacyHeader}</b>
                    </p>
                    <div style={{ marginTop: 10 }}>
                      <label style={{ marginLeft: 30 }}>{formSchema.privacyMsg}</label>
                      <label>
                        {' '}
                        <a href={formSchema.privacyUrl} target="_blank">
                          <b> Privacy Notice</b>
                        </a>
                      </label>
                    </div>
                  </>
                }
              />
              {!formSchema.disabled && (
                <Checkbox
                  style={{ marginLeft: 30, marginTop: 10 }}
                  checked={isAccept}
                  onChange={(_, ckeck) => {
                    setIsAccept(ckeck)
                  }}
                >
                  ยินยอม
                </Checkbox>
              )}
            </Row>

            {!isAccept && (
              <>
                <Message
                  showIcon
                  type="warning"
                  description={
                    <>
                      <p>
                        กรุณาอ่านข้อมูล PDPA และเงื่อนไขการใช้ข้อมูล แล้วเลือก "ยินยอม"
                        เพื่อทำแบบประเมิน
                      </p>
                    </>
                  }
                />
              </>
            )}

            {(isAccept || preView) && (
              <>
                {!formSchema.disabled ? (
                  <>
                    <MAndESelfForm
                      schema={formSchema}
                      unauthen={unauthen}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      getValues={getValues}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      setAssessmentResult={setResult}
                      setAssessmentBasicResult={setBasicInfoResult}
                    />
                  </>
                ) : (
                  <MAndESelfView schema={formSchema} />
                )}

                <hr />
                {unauthen ? (
                  <>
                    <div
                      style={{
                        zIndex: 998,
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        backgroundColor: '#f4f9ff',
                        borderRadius: 5,
                        textAlign: 'center',
                      }}
                    >
                      <div style={{ paddingBottom: 10 }}>
                        {!formSchema.disabled && (
                          <div style={{ marginTop: 10 }}>
                            <b>
                              <label
                                style={{
                                  color:
                                    (result?.size || 0) + (basicInfoResult?.size || 0) ==
                                    formSchema.totalAssessment + extendResult
                                      ? '#2da888'
                                      : '#fb8a81',
                                }}
                              >
                                <h4>
                                  {(result?.size || 0) + (basicInfoResult?.size || 0)} /{' '}
                                  {formSchema.totalAssessment + extendResult}
                                </h4>
                              </label>
                            </b>
                          </div>
                        )}

                        <div style={{ marginTop: 10 }}>
                          {formSchema.saveDraftBtn && (
                            <SaveButton
                              className={'rs-panel-shaded'}
                              onClick={onSubmitDaft}
                              style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                            >
                              {formSchema.saveDraftBtn}
                            </SaveButton>
                          )}
                          {formSchema.saveBtn && (
                            <SaveButton
                              className={'rs-panel-shaded'}
                              icon="send"
                              onClick={() => {
                                handleSubmit(onSubmitAndSend)()
                                if (Object.keys(errors).length > 0) {
                                  notification.open('error', {
                                    title: 'กรุณากรอกข้อมูลและแบบประเมินให้ครบถ้วน',
                                    duration: 5000,
                                  })
                                }
                              }}
                              style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                              disabled={!isAccept}
                            >
                              {formSchema.saveBtn}
                            </SaveButton>
                          )}

                          <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <Row style={{ marginTop: 20 }}>
                      <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                        {formSchema.saveDraftBtn && (
                          <SaveButton
                            className={'rs-panel-shaded'}
                            onClick={onSubmitDaft}
                            style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                          >
                            {formSchema.saveDraftBtn}
                          </SaveButton>
                        )}
                        {formSchema.saveBtn && (
                          <SaveButton
                            className={'rs-panel-shaded'}
                            icon="send"
                            onClick={() => {
                              handleSubmit(onSubmitAndSend)()
                              if (Object.keys(errors).length > 0) {
                                notification.open('error', {
                                  title: 'กรุณากรอกข้อมูลและแบบประเมินให้ครบถ้วน',
                                  duration: 5000,
                                })
                              }
                            }}
                            style={{ marginRight: 10, marginBottom: 10, backgroundColor: '#fff' }}
                            disabled={!isAccept}
                          >
                            {formSchema.saveBtn}
                          </SaveButton>
                        )}

                        <CancelButton onClick={handleCancel}>ยกเลิก</CancelButton>
                      </Col>
                    </Row>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={formSchema.saveBtn}
        show={isShowConfirm}
        detail={`ยืนยันการ ${formSchema.saveBtn}`}
        onCancle={() => {
          setIsShowConfirm(false)
        }}
        onConfirm={() => {
          onSubmit(submitSendData)
        }}
      />
    </>
  )
}
